/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSubmissionsCycle } from '../../models/page-submissions-cycle';

export interface GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Params {
  org: string;
  mode?: ('upstream' | 'secretariat' | null);

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet(http: HttpClient, rootUrl: string, params: GetAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsCycle>> {
  const rb = new RequestBuilder(rootUrl, getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('mode', params.mode, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSubmissionsCycle>;
    })
  );
}

getAllSubmissionsCyclesApiV2SubmissionsCycleOrgAllGet.PATH = '/api/v2/submissions-cycle/{org}/all';
